import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/myitemcard.module.scss'

import { getImageUrl } from '../util/images'
import FavoriteItem from '../items/FavoriteItem'
import { getItemUserStatus } from '../components/utils'
import { formatMoney } from 'services/util'

export default function MyUpcomingItemCard({item, auction, currentUserId}) {

  const [imageUrl, setImageUrl] = useState()

  // const itemUserStatus = getItemUserStatus(auction, item, currentUserId)
  // const outlineClass = itemUserStatus ? themeCss[`outline-${itemUserStatus}`] : ''

  console.log('auction', auction)

  const currentBidText = () => {
    if (auctionState === 'ended') return 'Winning Bid'
    if (item.CurrentBid) return 'Current Bid'
    return 'Starting Bid'
  }
  
  let auctionState = ''
  const now = new Date()
  const startDate = new Date(auction.StartTime)
  startDate < now ? auctionState = 'started' : auctionState = 'before'


  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  const isHighBidder = item.CurrentHighBidder === currentUserId

  //set the item id for if it is an item or fixed item
  let favoriteId = ''
  if (item.ItemId) favoriteId = item.ItemId
  else if (item.FixedItemId) favoriteId = item.FixedItemId


  // if (!auction.Favorites?.includes(favoriteId)) return <></>
  // if (auctionState === 'ended' && !isHighBidder) return <></> 

  return (
    <div className={`${css['myitem-container']} ${themeCss['shadowed']}`}>
      <Link className={css['myitem-image']} to={{ pathname: '/auction/item', search: `?auctionId=${auction.AuctionCode}&itemId=${item.ItemCode}`}}>
        <img src={imageUrl} alt={`${item.Title}`} />
        <p className={`${css['myitem-title']} ${themeCss['truncate-twoline']}`}>
          {item.Title}
        </p>
      </Link>

      {auctionState !== 'before' && 
      <div className={css['myitem-bidinfo']}>
        <p>
          {currentBidText()} 
            <span>
              ${formatMoney(item.CurrentBid ? item.CurrentBid : item.StartingBid)}
            </span>
        </p>
        <p className={css['myitem-bidcount']}>{item.BidCount} {item.BidCount === 1 ? 'bid' : 'bids'}</p>
      </div>}

      <div className={css['myitem-footer']}>
        <FavoriteItem auctionId={auction.AuctionId} itemId={favoriteId}/>
        <Link to={{ pathname: '/auction/item', search: `?auctionId=${auction.AuctionCode}&itemId=${item.ItemCode}`}}
            className={`${css['myitem-view-link']}`}>
          View Item Details
        </Link>
      </div>

    </div>
  )
}